import { useState } from 'react';
import { toast } from 'sonner';
import { Heart, Users, MapPin } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

export default function AmbassadorsPage() {
  const [form, setForm] = useState({ name: '', commune: '', motivation: '' });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.commune || !form.motivation) return toast.error('Champs requis');
    setSent(true);
    toast.success('Candidature envoyée — l’équipe vous recontacte sous 7 jours');
  };

  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-10 space-y-6">
      <div className="text-center">
        <Heart size={44} className="mx-auto text-[#CE1021]" />
        <h1 className="text-3xl md:text-4xl font-bold mt-2">Programme Ambassadeurs</h1>
        <p className="text-slate-600 mt-2 max-w-2xl mx-auto">Devenez l&apos;ambassadeur de Job Kongo dans votre commune. Animez la communauté locale, aidez à la vérification, bénéficiez de récompenses.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {[
          { icon: Users, title: 'Animez', desc: 'Organisez des rencontres locales entre jobeurs et clients.' },
          { icon: MapPin, title: 'Représentez', desc: 'Soyez le visage de Job Kongo dans votre commune.' },
          { icon: Heart, title: 'Gagnez', desc: 'Badge spécial, avantages exclusifs, commissions partenaires.' },
        ].map((i) => (
          <Card key={i.title} className="p-5 text-center">
            <div className="h-12 w-12 mx-auto rounded-xl bg-[#EAF3FF] text-[#1677F2] flex items-center justify-center mb-2"><i.icon size={22} /></div>
            <p className="font-semibold">{i.title}</p>
            <p className="text-sm text-slate-600 mt-1">{i.desc}</p>
          </Card>
        ))}
      </div>

      <Card className="p-6">
        <h2 className="text-xl font-bold">Postuler</h2>
        {sent ? (
          <p className="mt-3 text-[#16764A]">Merci ! Nous revenons vers vous sous 7 jours.</p>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-3">
            <div><Label>Nom complet</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="ambassador-name" /></div>
            <div><Label>Commune / Ville</Label><Input value={form.commune} onChange={(e) => setForm({ ...form, commune: e.target.value })} data-testid="ambassador-commune" /></div>
            <div><Label>Pourquoi vous ?</Label><Textarea rows={4} value={form.motivation} onChange={(e) => setForm({ ...form, motivation: e.target.value })} data-testid="ambassador-motivation" /></div>
            <Button type="submit" className="bg-[#1677F2] hover:bg-[#0F5FCC]" data-testid="ambassador-submit-btn">Envoyer ma candidature</Button>
          </form>
        )}
      </Card>
    </div>
  );
}
